<template>
    <base-modal :visible="true" @close="$emit('close')" title="Edit column">
        <column-form
            :init_data="copy(column)"
            :loading="update.loading"
            @cancel="$emit('close')"
            @submit="submit"/>
    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import ColumnForm from './ColumnForm.vue';

export default {
    components: { ColumnForm },
    props: ['space', 'flow', 'column'],
    computed: mapState('columns', ['update']),
    methods: {
        async submit(data) {
            const column = await this.$store.dispatch('columns/update', {
                column_id: this.column.id,
                space_id: this.space.id,
                flow_id: this.flow.id,
                data,
            });

            this.$store.commit('columns/update_column', {
                id: column.id,
                name: column.name,
                color: column.color,
            });

            this.$emit('close');
        },
    },
};
</script>
